import React from 'react'
import { useForm, FormProvider } from "react-hook-form";

function Form(props) {

  const  formMethods = useForm();

  const {
    handleSubmit,
  } = formMethods;

  const onSubmit = (data) => {
    // var = props.dispatch
    // dispatch action (varNAme)
    // alert(JSON.stringify(data, null, 4));
    alert("Thank you");
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>{props.children}</form>
    </FormProvider>
  );
}


export default Form

// 2.0 REDDUX FORM TEST
// const LoginForm = (props) => {
//   return (
//     <form onSubmit={props.handleSubmit}>   
//       <div>
//         <Field type="text" placeholder='name' name={"name"} component={'input'}/>
//       </div>
//       <div>
//         <Field type="text" placeholder='email' name={"email"}  component={'input'}/>
//       </div>
//       <div>
//         <button>Send</button>
//       </div>
//     </form>
//   )
  
// }

// const LoginReduxForm = reduxForm({
//   form: 'test'
// })(LoginForm)

// function Form() {
//   return (
//     <div>
//       <h1>Form test</h1>
//       <LoginReduxForm/>
//     </div>
//   )
// }


// export default Form


// Version 1.0
// import React from 'react'

// function Form(props) {
//     return (
//       <div>
//             {/* <div class="form-block w-form"> This class create a bug */}
//                 <form id="email-form" name="email-form" data-name="Email Form" method="get">
//                     {props.children}
//                     <div class="form-button-container"><input type="submit" value="Submit" data-wait="Please wait..." class="button w-button" /></div>
//                 </form>
//             {/* </div> */}
//       </div>
        
//     )
// }

// export default Form